import { render } from "./Main.vue?vue&type=template&id=f2777cee&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=f2777cee&scoped=true&lang=css"
import "./Main.vue?vue&type=style&index=1&id=f2777cee&lang=css"

import exportComponent from "/codebuild/output/src1910356388/src/ilongevity-backoffice/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2777cee"]])

export default __exports__